import { createSelector } from "reselect";

import { getCart } from "./state-accessors";
import * as CART_STATUS from "../constants/cart-status";

export const getCompletedCart = createSelector([getCart], cart =>
  cart?.status === CART_STATUS.DONE ? cart.cart : null
);

export const getCompletedCartType = createSelector([getCart], cart =>
  cart?.status === CART_STATUS.DONE ? cart.departure_type : null
);

export const isCartAsync = createSelector([getCart], cart =>
  cart?.status === CART_STATUS.DONE ? cart?.is_async_cart : false
);
